import { HttpBackend, HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class ShoppingService {

    http: HttpClient;
    servicePlanPath = 'ServicePlan';
    serviceTypePath = 'ServiceType';
    guestOrderPath = 'Order';
    guestCartPath = 'OrderServicePlan';
    cartCheckPath = 'CustomerPayment';
    serviceProviderPath = 'ServiceProvider';

    get baseUrl(): string {
        if (window.location.href.includes('upper.health') || window.location.href.toLowerCase().includes('uppercustomerportal.z13.web.core.windows.net')) {
            return 'https://upper-api.azurewebsites.net';
        } else if (window.location.href.includes('localhost')) {
            return 'https://localhost:5001';
        }
        return 'https://upper-qa-api.azurewebsites.net';
    }

    constructor(handler: HttpBackend) {
        this.http = new HttpClient(handler);
    }

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
        })
    };

    getShoppingServicePlans(pathSegments: string[], queryParameters: Map<string, any>): Observable<any> {
        const pathSegmentString = this._buildPathSegments(pathSegments);

        const queryParameterString = this._buildQueryParameters(queryParameters);

        return this.http.get<any>(
            `${this.baseUrl}/${this.servicePlanPath}${pathSegmentString}${queryParameterString}`,
            {
                ...{
                    headers: new HttpHeaders({
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Expose-Headers': ['x-pagination'],
                    })
                },
                observe:'response'
            }
        );
    }

    getShoppingServicePlanById(pathSegments: string[], queryParameters?: Map<string, any>): Observable<any> {
        if (queryParameters == null) {
            queryParameters = new Map();
        }
        const pathSegmentString = this._buildPathSegments(pathSegments);
        const queryParameterString = this._buildQueryParameters(queryParameters);

        return this.http.get<any>(
            `${this.baseUrl}/${this.servicePlanPath}${pathSegmentString}${queryParameterString}`,
            this.httpOptions,
        );
    }


    getStates(pathSegments: string[], queryParameters: Map<string, any>): Observable<any> {
        const pathSegmentString = this._buildPathSegments(pathSegments);
        const queryParameterString = this._buildQueryParameters(queryParameters);

        return this.http.get<any>(
            `${this.baseUrl}/${this.serviceProviderPath}${pathSegmentString}${queryParameterString}`,
            this.httpOptions,
        );
    }

    getAllShoppableServiceTypes(pathSegments: string[], queryParameters: Map<string, any>): Observable<any[]> {
        const pathSegmentString = this._buildPathSegments(pathSegments);
        const queryParameterString = this._buildQueryParameters(queryParameters);

        return this.http.get<any[]>(
            `${this.baseUrl}/${this.serviceTypePath}${pathSegmentString}${queryParameterString}`,
            this.httpOptions,
        );
    }

    updateGuestCart(pathSegments: string[], body: any): Observable<any> {
        const pathSegmentString = this._buildPathSegments(pathSegments);

        return this.http.put<any>(
            `${this.baseUrl}/${this.guestCartPath}${pathSegmentString}`,
            JSON.stringify(body),
            this.httpOptions,
        );
    }

    updateGuestOrder(pathSegments: string[], body: any): Observable<any> {
        const pathSegmentString = this._buildPathSegments(pathSegments);

        return this.http.put<any>(
            `${this.baseUrl}/${this.guestOrderPath}${pathSegmentString}`,
            JSON.stringify(body),
            this.httpOptions,
        );
    }

    updateCartStock(pathSegments: string[], body: any): Observable<any> {
        const pathSegmentString = this._buildPathSegments(pathSegments);

        return this.http.put<any>(
            `${this.baseUrl}/${this.cartCheckPath}${pathSegmentString}`,
            JSON.stringify(body),
            this.httpOptions,
        );
    }

    public _buildPathSegments(pathSegments: string[]): string {
        return pathSegments != null && pathSegments.length > 0 ? `/${pathSegments.join('/')}` : '';
    }

    public _buildQueryParameters(queryParameters: Map<string, any>): string {
        return queryParameters != null && queryParameters.size > 0
            ? `?${Array.from(queryParameters.keys()).map(key => key + '=' + queryParameters.get(key)).join('&')}`
            : '';
    }
}